export default "__VITE_ASSET__Do91wRIP__"